import Vue from 'vue';
import Avatar from './components/avatar.vue'
import App from './App.vue';
import router from './router';
import store from './store';
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import Common from '../static/js/common.js'; //引入静态资源
import VueClipboard from 'vue-clipboard2'
import VueWechatTitle from 'vue-wechat-title' //动态修改路由title
import '../static/iconfont/iconfont.css' // 导入字体图标库
import '../static/swiper/swiper.min.css' // 导入轮播图样式
import 'amfe-flexible';
import '@vant/touch-emulator';

// import tim from './tim'
// import TIM from 'tim-js-sdk'
// window.tim = tim
// window.TIM = TIM
// Vue.prototype.tim = tim
// Vue.prototype.TIM = TIM

VueClipboard.config.autoSetContainer = true
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
Vue.prototype.$video = Video
Vue.prototype.Common = Common; //全局配置Common方法
Vue.prototype.awardYear = "2025"; //全局配置年份
Vue.use(VueClipboard)
Vue.use(VueWechatTitle)
Vue.component('avatar', Avatar)
Vue.config.ignoredElements = ['wx-open-launch-weapp']; //引入跳转小程序插件
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// Vue.use(vConsole);
import { configHandle } from "@/utils/share";
router.beforeEach((to, from, next) => {
    // beforeEach是router的钩子函数，在进入路由前执行
    /* vue-router用的history模式，在微信签名验证的时候iOS验证URL第一次进来的URL */
    if (from.path === '/') {
        configHandle(92918, window.location.href)
    }
    if (to.meta.title) { // 判断是否有标题
        document.title = to.meta.title
    }
    next() // 执行进入路由，如果不写就不会进入目标页
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')